module.exports = "import React from 'react';\nimport { Level, LevelItem } from '@patternfly/react-core';\n\nclass LevelWithGutters extends React.Component {\n  render() {\n    return (\n      <Level gutter=\"md\">\n        <LevelItem>Level Item</LevelItem>\n        <LevelItem>Level Item</LevelItem>\n        <LevelItem>Level Item</LevelItem>\n      </Level>\n    );\n  }\n}\n\nexport default LevelWithGutters;\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/raw-loader!../react-core/src/layouts/Level/examples/LevelWithGutters.js
// module id = 463
// module chunks = 114276838955818 141669503851301